import { Card } from "antd";
import React, { useEffect, useState } from "react";
import Utils from "../../utils/Utils";

function InterviewAnalysisFirstSec({ interviewAnalysisDataConfig }) {
  // let interviewData = {
  //   interviewId: "231_354454_2565",
  //   jobTitle: "gg",
  //   companyName: "amazon",
  //   interviewDuration: 60,
  //   candidateName: "sravan akhil",
  //   emailId: "gg@gmail.com",
  //   interviewCompletionDate: "2024-10-25T09:30:32.936+00:00",
  //   ipLog: "192.33",
  // };
  const [interviewData, setInterviewData] = useState();
  useEffect(() => {
    if (interviewAnalysisDataConfig) {
      setInterviewData(interviewAnalysisDataConfig);
    }
  }, [interviewAnalysisDataConfig]);
  return (
    <div className="flex flex-col md:flex-row gap-[.85rem]  w-full mt-4">
      <Card className="md:w-[50%] w-full bg-[#D4E7FD] text-[1rem] md:text-[1.1rem] leading-5 rounded-[10px] shadow-lg border border-[#A9CFFB] py-1 px-0 sm:px-2">
        <div className="flex gap-[.42rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Interview ID</p>
          <p className="w-[61%] text-[#101828] break-words">
            {interviewData?.interviewId || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.85rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Job title</p>
          <p className="w-[61%] text-[#101828] break-words">
            {interviewData?.jobTitle || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.85rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Company name</p>
          <p className="w-[61%] text-[#101828] break-words">
            {interviewData?.companyName || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.85rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Duration</p>
          <p className="w-[61%] text-[#101828]">
            {Utils.convertSecondsToTime(interviewData?.interviewDuration || 0)}{" "}
          </p>
        </div>
      </Card>
      <Card className="md:w-[50%] w-full bg-[#D4E7FD] text-[1rem] md:text-[1.1rem] leading-5 rounded-[10px] shadow-lg border border-[#A9CFFB] py-1 px-0 sm:px-2">
        <div className="flex gap-[.42rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Candidate name</p>
          <p className="w-[61%] text-[#101828] break-words">
            {interviewData?.candidateName || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.85rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Email ID</p>
          <p className="w-[61%] text-[#101828] break-words	">
            {interviewData?.emailId || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.85rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Timestamp</p>
          <p className="w-[61%] text-[#101828]">
            {Utils.converToDateMonthYear(
              interviewData?.interviewCompletionDate
            ) || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.85rem] font-semibold">
          <p className="w-[37%] text-[#475467]">IP log</p>
          <p className="w-[61%] text-[#101828]">
            {interviewData?.ipLog || "N/A"}
          </p>
        </div>
      </Card>
    </div>
  );
}

export default InterviewAnalysisFirstSec;
